const state = {
  all: [],
  gstList: [],
  excludeList: [],
  isLoading: false,
  isUpdating: false,
  isUploading: false,
  isDownloading: false,
  isPaginating: false,
  hasEmpty: false,
  isShowLoading: false,
  filter: {
    page: 1,
    query: null,
  },
  exceptionList: [],
  currentBdr: {},
  header: [],
  slabData: [],
  dedicatedTruckHistory: {},
};

export default state;
